import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from '../ui/dialog';
import { Button } from '../ui/button';

export const DirtyStateDialog = ({ open, onConfirm, onCancel }) => (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onCancel(); }}>
        <DialogContent>
            <DialogHeader>
                <DialogTitle>Modifications non enregistrées</DialogTitle>
                <DialogDescription>
                    Vous avez des modifications non enregistrées. Si vous quittez cette page, vos changements seront perdus.
                </DialogDescription>
            </DialogHeader>
            <DialogFooter className="flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2">
                <Button variant="outline" onClick={onCancel}>
                    Rester sur cette page
                </Button>
                <Button className="bg-destructive text-destructive-foreground hover:bg-destructive/90" onClick={onConfirm}>
                    Quitter sans enregistrer
                </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
);

export default DirtyStateDialog;
